import { defaultFormatChars } from "../constants.js";
function parseMask({ mask, maskPlaceholder, formatChars }) {
    const currentFormatChars = null != formatChars ? formatChars : defaultFormatChars;
    const permanents = [];
    if (!mask) return {
        maskPlaceholder: null,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
    };
    let parsedMask;
    if ('string' == typeof mask) {
        let isPermanent = false;
        let parsedMaskString = '';
        mask.split('').forEach((character)=>{
            if (isPermanent || '\\' !== character) {
                if (isPermanent || !currentFormatChars[character]) permanents.push(parsedMaskString.length);
                parsedMaskString += character;
                isPermanent = false;
            } else isPermanent = true;
        });
        parsedMask = parsedMaskString.split('').map((character, index)=>{
            if (-1 === permanents.indexOf(index)) return currentFormatChars[character];
            return character;
        });
    } else {
        parsedMask = mask;
        mask.forEach((character, index)=>{
            if ('string' == typeof character) permanents.push(index);
        });
    }
    let parsedMaskPlaceholder = maskPlaceholder || null;
    if (parsedMaskPlaceholder) if (1 === parsedMaskPlaceholder.length) {
        const placeholderArray = parsedMask.map((character, index)=>{
            if (-1 !== permanents.indexOf(index)) return character;
            return parsedMaskPlaceholder;
        });
        parsedMaskPlaceholder = placeholderArray.join('');
    } else {
        const placeholderArray = parsedMaskPlaceholder.split('');
        permanents.forEach((position)=>{
            placeholderArray[position] = parsedMask[position];
        });
        parsedMaskPlaceholder = placeholderArray.join('');
    }
    const prefix = permanents.filter((position, index)=>position === index).map((position)=>parsedMask[position]).join('');
    let lastEditablePosition = parsedMask.length - 1;
    while(-1 !== permanents.indexOf(lastEditablePosition))lastEditablePosition--;
    return {
        maskPlaceholder: parsedMaskPlaceholder,
        prefix,
        mask: parsedMask,
        lastEditablePosition,
        permanents
    };
}
export default parseMask;
